import React, { useEffect } from 'react'
import './Gurudevs_Shorts.css'
import Common_Title_3 from '../../common/common_components/Common_Title_3/Common_Title_3'
import { useDispatch, useSelector } from 'react-redux'
import { GuruShorts } from '../../../features/admin/common/Slice'
import { IDS } from '../../../utils/IDS'

const Gurudevs_Shorts = () => {

    const data = [
        "/assets/images/home/shorts/img3.jpg",
        "/assets/images/home/shorts/img4.jpg",
        "/assets/images/home/shorts/img5.jpg",
        "/assets/images/home/shorts/img6.jpg",
    ]


    const dispatch = useDispatch();
    const guru_shorts = useSelector((state) => state.common.guru_shorts);

    useEffect(() => {
        dispatch(GuruShorts());
    }, [dispatch])
    return (
        // guru_shorts?.length > 0 && (

        <section className='Gurudevs_Shorts'>
            <div className='container'>

                <Common_Title_3 titleText="Gurudev's Shorts" seelink="/gurudev" hideSeeAll />

                <div className='content_div'>
                    <div className='row'>
                        {guru_shorts?.map((item, index) => {
                            return (
                                <div key={index} className='col-lg-3 col-md-4 col-6 mb-3'>
                                    <div className='shorts_div'>
                                        <video
                                            src={IDS.IMG_URL + item?.video}
                                            className='img_div'
                                            controls        // show play, pause, etc
                                            // muted           // required for autoplay on web
                                            // autoPlay        // optional
                                            loop            // optional for shorts style repeat
                                        />
                                    </div>
                                </div>
                            );
                        })}



                    </div>
                </div>
                {/* <div className='content_div'>
                    <div className='row'>
                    {guru_shorts?.map((item) => {
                        return (
                            <div className='col-lg-3 col-md-4 col-6 mb-3'>
                            <div className='shorts_div'>
                            <img src={process.env.PUBLIC_URL + item} className='img_div' />
                            </div>
                            </div>
                            )
                            })}
                            
                            
                            </div>
                            </div> */}

            </div>
        </section>
    )
    // )
}

export default Gurudevs_Shorts
